






















































import Vue from "vue"
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock"
import Overlay from "~/components/guideline/modal/Overlay.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    Overlay,
    MaterialIcon,
  },
  props: {
    isVisibleHead: {
      type: Boolean,
      default: false,
    },
    headTitle: {
      type: String,
      default: "",
    },
    isVisibleCloseIcon: {
      type: Boolean,
      default: false,
    },
    isShown: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
    isFullScreenMode(): boolean {
      return this.$device.isMobile
    },
  },
  watch: {
    isShown() {
      if (this.isShown) {
        const ref = this.$refs.richModal as HTMLElement
        disableBodyScroll(ref)
      } else {
        clearAllBodyScrollLocks()
      }
    },
  },
  methods: {
    handleClickCloseIcon() {
      this.$emit("click-close-icon")
    },
    handleClickOverlay() {
      this.$emit("click-overlay")
    },
  },
})
